export default __webpack_public_path__ + "static/media/totem touchone.d487f405.png";